var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sp_test"},[_c('sp-table',{attrs:{"tableParams":_vm.tableParams}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }